const rawBase: string | undefined = import.meta.env.VITE_PUBLIC_SUPABASE_URL;

export const API_BASE = (rawBase || "").replace(/\/+$/, "");

export interface ApiError extends Error {
  status?: number;
}

export interface ListResponse {
  ok: boolean;
  count?: number;
  data?: unknown[];
}

async function parseResponse<T>(res: Response): Promise<T> {
  const data = await res.json().catch(() => null);
  if (!res.ok || (data && data.ok === false)) {
    const message = data?.error || `Erro ${res.status}`;
    const err = new Error(typeof message === "string" ? message : "Erro na requisição") as ApiError;
    err.status = res.status;
    throw err;
  }
  return data as T;
}

function authHeaders(token?: string): Record<string, string> {
  const headers: Record<string, string> = {};
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
}

export async function apiGet<T = unknown>(path: string, token?: string): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, { headers: authHeaders(token) });
  return parseResponse<T>(res);
}

export async function apiPost<T = unknown>(path: string, body: unknown, token?: string): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeaders(token) },
    body: JSON.stringify(body),
  });
  return parseResponse<T>(res);
}

export async function apiPut<T = unknown>(path: string, body: unknown, token?: string): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeaders(token) },
    body: JSON.stringify(body),
  });
  return parseResponse<T>(res);
}

export async function apiDelete<T = unknown>(path: string, token?: string): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    method: "DELETE",
    headers: authHeaders(token),
  });
  return parseResponse<T>(res);
}